import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-with-close-button',
    templateUrl: './dialog-with-close-button.component.html',
    styleUrls: ['./dialog-with-close-button.component.scss'],
    standalone: false
})
export class DialogWithCloseButtonComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data:any) { }

  ngOnInit(): void {
  }

}
